import { lazy } from "react";

export const NotificationPage = lazy(() => import("./notificationPage"));
